import { render } from "./DocumentIcon.vue?vue&type=template&id=c2bb4e82"
import script from "./DocumentIcon.vue?vue&type=script&lang=js"
export * from "./DocumentIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__